import { BlockProps } from '../type';
import { IBillContent, IAccountBillContentBlock } from './type';

interface Props {
  key: string;
  label: string;
  data: IBillContent;
  currencyType: string;
  tableHeaderBgColor?: string;
  borderColor?: string;
  headerTextColor?: string;
  headerBorderColor?: string;
}

export const createBillContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'sales',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isSalesBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'sales';
}

export const createSalesReturnContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'sales_return',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isSalesSalesReturnContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'sales_return';
}

export const createPurchaseBillContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'purchase',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isPurchaseBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'purchase';
}

export const createPurchaseReturnBillContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'purchase_return',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isPurchaseReturnBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'purchase_return';
}

export const createKarigarReceiveContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'receive_karigar',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isKarigarReceiveBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'receive_karigar';
}

export const createReceivePartyContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'receive_party',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isReceivePartyBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'receive_party';
}

export const createReceiveRefineContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'receive_refine',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isReceiveRefineBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'receive_refine';
}

// { value: 'sales', label: 'Sales Bill' },
//{ value: 'purchase', label: 'Purchase Bill' },
//{ value: 'sales_return', label: 'Sales Return' },
//{ value: 'purchase_return', label: 'Purchase Return' },
//{ value: 'opening', label: 'Opening' },
//{ value: 'issue_party', label: 'Issue - Party' },
//{ value: 'issue_karigar', label: 'Issue - Karigar' },
//{ value: 'issue_refine', label: 'Issue - Refine' },
//{ value: 'receive_party', label: 'Receive - Party' },
//{ value: 'receive_karigar', label: 'Receive - Karigar' },
//{ value: 'receive_refine', label: 'Receive - Refine' },
//                 { value: 'sales_order', label: 'Sales Order' },
//                 { value: 'metal_cash_payment', label: 'Metal Cash Payment' },
//                 { value: 'metal_cash_receipt', label: 'Metal Cash Receipt' },
//                 { value: 'payment', label: 'Payment Voucher' },
//                 { value: 'receipt', label: 'Receipt Voucher' },
//                 { value: 'contra', label: 'Contra Voucher' },
//                 { value: 'journal', label: 'Journal Voucher' },

export const createJournalVoucherContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'journal',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isJournalVoucherContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'journal';
}

export const createContraVoucherContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'contra',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isContraVoucherContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'contra';
}

export const createReceiptVoucherContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'receipt',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isReceiptVoucherContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'receipt';
}

export const createPaymentVoucherContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'payment',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isPaymentVoucherContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'payment';
}

export const createMetalToCashReceiptContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'metal_cash_receipt',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isMetalToCashReceiptContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'metal_cash_receipt';
}

export const createMetalToCashPaymentContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'metal_cash_payment',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isMetalToCashContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'metal_cash_payment';
}

export const createOpeningContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'opening',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isOpeningContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'opening';
}

export const createSalesOrderContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'sales_order',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isSalesOrderContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'sales_order';
}

export const createIssueKarigarContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'issue_karigar',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isIssueKarigarBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'issue_karigar';
}

export const createIssueRefineContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'issue_refine',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isIssueRefineBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'issue_refine';
}

export const createIssuePartyContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'issue_party',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isIssuePartyBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'issue_party';
}

export const createMetalTransferContentBlock = (
  props: Props,
): IAccountBillContentBlock => {
  const block: IAccountBillContentBlock = {
    type: 'metal_transfer',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    ...props,
  };

  return block;
};

export function isMetalTransferBillContentBlock(
  block: BlockProps,
): block is IAccountBillContentBlock {
  return block.type === 'metal_transfer';
}
